export const money = (n) =>
  `GH₵ ${Number(n || 0).toLocaleString("en-GH", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const fmtTime = (dep) => (dep || "").slice(11, 16);

export const fmtDate = (d, opts = { weekday: "short", day: "numeric", month: "short" }) =>
  d ? new Date(`${d.slice(0, 10)}T00:00:00Z`).toLocaleDateString("en-GB", { ...opts, timeZone: "UTC" }) : "";

export const fmtDateTime = (iso) =>
  iso ? new Date(iso).toLocaleString("en-GB", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit", timeZone: "UTC" }) : "-";

export const addMinutes = (dep, m) => {
  const d = new Date(`${dep}:00Z`);
  d.setUTCMinutes(d.getUTCMinutes() + (m || 0));
  return d.toISOString().slice(11, 16);
};

export const durationText = (m) => (m ? `${Math.floor(m / 60)}h${m % 60 ? ` ${m % 60}m` : ""}` : "");

// Ghana runs on GMT, so UTC date == local date
export const todayStr = (offset = 0) => {
  const d = new Date();
  d.setUTCDate(d.getUTCDate() + offset);
  return d.toISOString().slice(0, 10);
};

export const TIERS = [
  { name: "Bronze", min: 0, color: "bg-amber-100 text-amber-800" },
  { name: "Silver", min: 500, color: "bg-slate-200 text-slate-700" },
  { name: "Gold", min: 2000, color: "bg-yellow-100 text-yellow-800" },
  { name: "Platinum", min: 5000, color: "bg-sky-100 text-sky-800" },
];

export const tierFor = (miles = 0) => {
  const idx = TIERS.reduce((acc, t, i) => (miles >= t.min ? i : acc), 0);
  return { ...TIERS[idx], next: TIERS[idx + 1] || null };
};

// Seat layout: 2+1 for up to 33 seats, 2+2 above; leftover seats form a back bench
export const LAYOUTS = ["2+1", "2+2", "3+2", "1+1"];

export function seatRows(cap, layout) {
  const [left, right] = (layout || (cap > 33 ? "2+2" : "2+1")).split("+").map(Number);
  const per = left + right;
  const rem = cap % per;
  const full = Math.floor(cap / per) - (rem ? 1 : 0);
  const rows = [];
  let n = 1;
  for (let r = 0; r < full; r++) rows.push({ bench: false, seats: Array.from({ length: per }, () => n++) });
  if (n <= cap) rows.push({ bench: true, seats: Array.from({ length: cap - n + 1 }, () => n++) });
  return { per, left, rows };
}

export const statusStyle = {
  confirmed: "bg-emerald-50 text-emerald-700 border-emerald-200",
  boarded: "bg-sky-50 text-sky-700 border-sky-200",
  reserved: "bg-amber-50 text-amber-700 border-amber-200",
  pending_payment: "bg-amber-50 text-amber-700 border-amber-200",
  payment_failed: "bg-rose-50 text-rose-700 border-rose-200",
  cancelled: "bg-rose-50 text-rose-700 border-rose-200",
  expired: "bg-slate-100 text-slate-600 border-slate-200",
  scheduled: "bg-blue-50 text-blue-700 border-blue-200",
  departed: "bg-slate-100 text-slate-700 border-slate-200",
  open: "bg-emerald-50 text-emerald-700 border-emerald-200",
  closed: "bg-amber-50 text-amber-700 border-amber-200",
  received: "bg-sky-50 text-sky-700 border-sky-200",
  handover_pending: "bg-violet-50 text-violet-700 border-violet-200",
  handed_over: "bg-slate-100 text-slate-600 border-slate-200",
};

export const METHOD_LABEL = { cash: "Cash", momo: "Mobile Money", card: "Card", online: "Online" };
export const AMENITIES = ["AC", "WiFi", "USB Charging", "Reclining Seats", "TV", "Luggage Hold", "Toilet", "Water"];
export const BUS_TYPES = ["VIP Executive", "Standard Coach", "Mid-size Coach", "Sprinter", "Mini Bus"];
